module.exports = __webpack_public_path__ + "media/images/icare-logo-homepage-6792b27fa8b813ecf58584f08c1d6174.png";